// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"579":"bebaa3e3","842":"caf46adf"}[chunkId] + ".chunk.js";
};